<template>
    <el-dialog title="转交" :visible.sync="dialog.visible" width="30%" :before-close="closeDialog">
        <el-form :model="ruleForm" ref="ruleForm" label-position="left" label-width="80px" :rules="approvalFormRules">
            <el-form-item label="所属公司" prop="company_id">
                <el-select v-model="ruleForm.company_id" filterable clearable placeholder="请选择所属公司">
                    <el-option v-for="(item, index) in companyList" :key="index" :label="item.title" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="审批人" prop="quilt_modified_id">
                <el-select v-model="ruleForm.quilt_modified_id" filterable clearable placeholder="请选择审批人">
                    <el-option v-for="(item, index) in userList" :key="index" :label="item.realname" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="转交人" prop="modified_id">
                <el-select v-model="ruleForm.modified_id" filterable clearable placeholder="请选择转交人">
                    <el-option v-for=" (item, index) in userList" :key="index" :label="item.realname" :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialog">取 消</el-button>
            <el-button type="primary" @click="submit">确 定</el-button>
        </div>
    </el-dialog>
</template>

<script>
    const ruleForm = {
        company_id: '',
        quilt_modified_id: '',
        modified_id: ''

    };
    export default {
        name: 'saveApproval',
        props: {
            companyList: {
                type: Array,
                default () {
                    return []
                }
            },
            typeList: {
                type: Array,
                default () {
                    return []
                }
            },
        },
        data() {
            return {
                dialog: {
                    title: '',
                    visible: false,
                    type: ''
                },
                userList: [],
                ruleForm: Object.assign({}, ruleForm),
                approvalFormRules: {
                    quilt_modified_id: [{
                        required: true,
                        message: '请选择审批人',
                        trigger: 'change'
                    }],
                    modified_id: [{
                        required: true,
                        message: '请选择转交人',
                        trigger: 'change'
                    }]
                },
            };
        },
        methods: {
            // 显示
            showDialog() {
                this.dialog.visible = true;
                this.getUserList()
            },
            // 获取用户列表
            getUserList() {
                let url = '/api/audit.dictionary/condition';
                this.$post(url).then(res => {
                    if (res.code == 200) {
                        this.userList = res.data.userList;
                    } else {
                        this.$message.error(res.msg);
                    }
                });
            },
            // 关闭
            closeDialog() {
                this.$refs['ruleForm'].resetFields();
                this.ruleForm = Object.assign({}, ruleForm)
                this.dialog.visible = false;
            },

            // 提交
            submit() {
                let that = this;
                let params = that.ruleForm;
                let url = 'api/audit.audit/staffUpdate'
                that.$refs['ruleForm'].validate((valid) => {
                    if (valid) {
                        this.$post(url, params).then(function (response) {
                            if (response.code == 200) {
                                that.$emit('getTableData');
                                that.closeDialog();
                                that.$message.success(response.msg)
                            } else {
                                that.$message.error(response.msg)
                            }
                        });
                    } else {
                        that.$message.warning('请检查您的填写');
                    }
                });
            }
        }
    };
</script>